<template>
  <div class="row-item">
    <div class="item-header">
      <button class="button is-text drag">
        <img
          src="@/assets/icons/drag.svg"
          alt="" />
      </button>

      <h3>{{ inputs.name }}</h3>
      <button
        type="button"
        class="delete"
        @click="$emit('delete')" />
    </div>
    <div class="tabs">
      <Tabs
        v-model="inputSectionTab"
        :tabs="tabs"
        :is-objects="true" />
    </div>

    <div
      v-if="inputSectionTab === 'label'"
      class="">
      <b-field
        label="Display Label"
        class="input-field"
        message="">
        <b-input
          v-model="inputs.name" />
      </b-field>
    </div>

    <div v-if="inputSectionTab === 'measure'">
      <TotalColumnMeasureTab
        v-model="inputs"
        :errors="errors"
        :context="context" />
    </div>
  </div>
</template>

<script>

  import Tabs from '@/components/pdf_report/Tabs.vue'

  import TotalColumnMeasureTab from './TotalColumnMeasureTab.vue'

  export default {
    name: 'TrackerRowTotal',
    components: {
      TotalColumnMeasureTab,
      Tabs,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
      context: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        inputSectionTab: 'label',
      }
    },

    computed: {
      tabs () {
        return [
          { label: 'Label', id: 'label', hasErrors: false, },
          { label: 'Measure', id: 'measure', hasErrors: this.errors.length > 0, },
        ]
      },
      inputs: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },

    beforeDestroy () {},

    methods: {},
  }
</script>

<style lang="scss" scoped>
.row-item {
  margin: 10px 0;
  border: $border-1;
  padding: 15px 20px;
  background-color: white;
  border-radius: 10px;

  .item-header {
    display: flex;
    margin-bottom: 20px;
    align-items: center;

    .drag {
      width: 25px;
      height: 25px;
      padding: 0;
      img {
        width: 20px;
      }
    }

    h3 {
      font-size: 15px;
    }

    .delete {
      margin-left: auto;
    }
  }
}

.tabs {
  width: 100%;
}
</style>

